import api from "../api/api";
import { useUserStore } from "../store/user-store";
import { Callback, Tema } from "../types/general";
import useTemaStore from "../zustand/use-tema-store";

function useTemaModel() {

  const {
    temas,
    setTemas,
    setSelectedTema,
    resetState,
    removeTema,
    updateTema,
  } = useTemaStore();

  const { user } = useUserStore();


  // Fetch all temas with pagination
  const fetchTemas = async (page: number = 1) => {
    try {
      const response = await api.get({
        path: "/api/temas",
        params: { page, all: 'true' },
      }, (data: any) => {
        setTemas(data);
      }, (error: any) => {
        alert(JSON.stringify(error))
      });

      return response;
    } catch (error) {
      console.error("Error fetching temas:", error);
      throw error;
    }
  };

  // Fetch temas only for the current user
  const fetchMyTemas = async (page: number = 1) => {
    try {
      const response = await api.get({
        path: "/api/temas/users/" + user?.id,
        params: { page, all: 'true' },
      }, (data: any) => {
        setTemas(data);
      }, (error: any) => {
        alert(JSON.stringify(error))
      });

      return response;
    } catch (error) {
      console.error("Error fetching my temas:", error);
      throw error;
    }
  };

  // Create new tema
  const createTema = async (data: {
    nome: string, available: boolean
  }, callback?: Callback) => {
    try {
      api.post({
        path: "/api/temas",
        data: {
          nome: data.nome,
          available: true
        },
      }, (data) => {
        callback?.response?.(data);
        setTemas({
          ...temas,
          data: [...[data], ...temas.data]
        });
      }, (error) => {
        callback?.error?.(error)
      });
    } catch (error) {
      console.error("Error creating tema:", error);
      throw error;
    }
  };

  // Update existing tema
  const updateTemaById = async (tema: Tema, callback?: Callback) => {
    try {
      api.put({
        path: "/api/temas",
        params: { tema: tema.id },
        data: tema,
      }, (data: any) => {
        callback?.response?.(data);
        updateTema(data);
      }, (error) => {
        callback?.error?.(error);
      });
    } catch (error) {
      console.error("Error updating tema:", error);
      throw error;
    }
  };

  // Delete tema
  const deleteTemaById = async (id: number, callback: Callback) => {
    try {
      await api.delete({
        path: "/api/temas",
        params: { tema: id },
      }, (data: any) => {
        callback.response?.(data)
        removeTema(id);
      }, (error: any) => {
        callback.error?.(error);
      });
    } catch (error) {
      console.error("Error deleting tema:", error);
      throw error;
    }
  };

  // Fetch tema by ID
  const fetchTemaById = async (id: number, callback?: Callback) => {
    try {
      const response = await api.get({
        path: `/api/temas/${id}`,
      }, (data: any) => {
        console.log(data)
        callback?.response?.(data);
      }, (error: any) => {
        callback?.error?.(error);
      });

      return response;
    } catch (error) {
      console.error("Error fetching tema by ID:", error);
      throw error;
    }
  };

  // Recarrega um tema (com contagem de perguntas por nível) e actualiza a store
  const refreshTemaStats = async (id: number) => {
    await api.get({
      path: `/api/temas/${id}`,
    }, (data: any) => {
      updateTema(data);
    }, (error: any) => {
      console.error("Error refreshing tema stats:", error);
    });
  };

  return {
    refreshTemaStats,
    fetchTemas,
    fetchMyTemas,
    updateTemaById,
    deleteTemaById,
    createTema,
    fetchTemaById
  }
}

export default useTemaModel